import { Button } from 'antd';
import errorHandler from 'shared/utils/errorHandler';
import { useState } from 'react';
import { apiOms } from 'shared/api';
import { downloadAsFile } from 'helper';

export const PrintInvoiceDialog = ({ orderDetails }) => {
	const { invoiceUrl } = orderDetails;
	const [isLoading, setIsLoading] = useState(false);
	const isPrintInvoiceButtonDisabled = (orderDetails) => !orderDetails?.invoice?.invoiceUrl && !invoiceUrl;

	const handlePrintInvoice = async () => {
		try {
			var urlRegex = new RegExp(
				'https?://(www.)?[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)https?://(www.)?[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)'
			);

			if (invoiceUrl.match(urlRegex)) {
				return window.open(invoiceUrl, '_blank');
			}

			setIsLoading(true);

			// const res = await getS3Link([orderDetails.invoice.invoiceUrl]);
			// const s3Link = res?.data?.data?.list[0];
			// window.open(s3Link, '_blank');

			const type = 'invoice';
			const res = await apiOms.post(`/download/${type}`, { orderId: [orderDetails.id] }, { responseType: 'blob' });
			downloadAsFile({ data: res.data, fileName: `${type}s`, fileType: 'zip' });
		} catch (error) {
			errorHandler(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Button
			type="primary"
			size="large"
			onClick={handlePrintInvoice}
			disabled={isPrintInvoiceButtonDisabled(orderDetails)}
			loading={isLoading}
		>
			Print Invoice
		</Button>
	);
};
